import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { ROUTES } from '../../../core/constants/routes.constants';
import { FooterLink, SocialLink } from '../../interfaces/layout.type';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  protected readonly routes = ROUTES;
  protected readonly currentYear = new Date().getFullYear();

  protected readonly socialLinks: SocialLink[] = [
    { label: 'Facebook', icon: 'f', url: 'https://facebook.com' },
    { label: 'Instagram', icon: '📷', url: 'https://instagram.com' },
    { label: 'YouTube', icon: '▶', url: 'https://youtube.com' },
    { label: 'Twitter', icon: '𝕏', url: 'https://twitter.com' },
    { label: 'WhatsApp', icon: '💬', url: 'https://wa.me' }
  ];

  protected readonly siteMapColumns: FooterLink[][] = [
    [
      { label: 'nav.home', path: ROUTES.HOME },
      { label: 'nav.quran', path: ROUTES.QURAN },
      { label: 'nav.duas_azkar', path: ROUTES.DUAS_AZKAR },
      { label: 'nav.amaal_planner', path: ROUTES.AMAAL_PLANNER }
    ],
    [
      { label: 'nav.qibla_finder', path: ROUTES.QIBLA_FINDER },
      { label: 'nav.masjids', path: ROUTES.MASJIDS },
      { label: 'nav.prayer_times', path: ROUTES.PRAYER_TIMES },
      { label: 'nav.99_names', path: ROUTES.NAMES_OF_ALLAH }
    ],
    [
      { label: 'nav.islamic_calendar', path: ROUTES.DASHBOARD_ISLAMIC_CALENDAR },
      { label: 'nav.history', path: ROUTES.HISTORY },
      { label: 'footer.sitemap.blog' },
      { label: 'footer.sitemap.contact_us' }
    ]
  ];

  protected readonly legalLinks: FooterLink[] = [
    { label: 'footer.legal.privacy' },
    { label: 'footer.legal.terms' },
    { label: 'footer.legal.help' }
  ];
}
